var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(" "+_vm._s(_vm.item.code)+" ")]),_c('td',[_c('div',{staticClass:"categories"},[(_vm.item.categories.length)?_vm._l((_vm.item.categories),function(category,index){return _c('div',{key:index},[_vm._v(_vm._s(category.name))])}):_c('span',[_vm._v(_vm._s(_vm.localStorage.translations.pages.common.text['net-dannyh']))])],2)]),_c('td',[_vm._v(" "+_vm._s(_vm.item.name)+" ")]),_c('td',[_vm._v(_vm._s(_vm.item.measure))]),_c('td',[_vm._v(_vm._s(_vm.$formatCurrency(_vm.item.price) + ' €'))]),_c('td',[_c('div',{staticClass:"buttons"},[(
          _vm.$userCheckAccess({
            abilities: 'edit_work_type',
          })
        )?_c('WorkTypeModal',{attrs:{"create":false,"id":_vm.item.id}}):_vm._e(),(
          _vm.$userCheckAccess({
            abilities: 'edit_work_type',
          })
        )?_c('DeleteModal',{attrs:{"item":_vm.item,"text":_vm.localStorage.translations.pages['setting-work_type']['dialog-delete'][
            'udalit-vid-raboty'
          ] +
          ' ' +
          _vm.item.name}}):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }